import ArticleBox from '~/themes/base/components/content/ArticleBox'

export default {
  extends: ArticleBox,
  props: {
    lazyImage: {
      type: Boolean,
      default: true,
    },
  },
}
